/**
 * People's names as one phrase in a sentence: "A", "A and B", "A, B and C"
 * (or with "or"). Blank names are left out; with none left, `fallback`
 * ("" by default, or e.g. "an Admin"). Shared by Setup's "Ask for a role" and
 * the Repos page's lock line so the two never word a list differently. Pure.
 */
export function joinNames(names: readonly string[], conjunction: "and" | "or", fallback = ""): string {
  const known = names.map((name) => name.trim()).filter(Boolean);
  if (known.length === 0) return fallback;
  if (known.length === 1) return known[0] ?? fallback;
  return `${known.slice(0, -1).join(", ")} ${conjunction} ${known[known.length - 1] ?? ""}`;
}
